module.exports = __webpack_public_path__ + "static/media/logBigPic.6047309f.jpeg";